module.exports = __webpack_public_path__ + "img/astropay-logo.747bf25.svg";